import { normalize } from "normalizr";

import * as apiHelper from "../../helpers/api";
import { requestWithAuth } from "../../utils/request";

import {
    REQUEST_COMPANIES,
    REQUEST_COMPANIES_SUCCESS,
    REQUEST_COMPANIES_FAILURE,
    REQUEST_COMPANY_TEAMS,
    REQUEST_COMPANY_TEAMS_SUCCESS,
    REQUEST_COMPANY_TEAMS_FAILURE,
    REQUEST_COMPANY,
    REQUEST_COMPANY_SUCCESS,
    REQUEST_COMPANY_FAILURE
} from "./types";
import companySchema from "../../schemas/company";
import teamSchema from "../../schemas/team";

const API_URL = apiHelper.getApiUrl();

// ----------------------------------------------------------------------
function requestCompany() {
    return { type: REQUEST_COMPANY };
}
function requestCompanyFailure(error) {
    return { type: REQUEST_COMPANY_FAILURE, error };
}
function requestCompanySuccess(entities, result) {
    return {
        type: REQUEST_COMPANY_SUCCESS,
        receivedAt: Date.now(),
        entities,
        company: result
    };
}

export function fetchCompany(companyId) {
    return dispatch => {
        dispatch(requestCompany());
        return requestWithAuth(dispatch, http =>
            http.get(`${API_URL}/companies/${companyId}`)
        )
            .then(({ data }) => {
                const { entities, result } = normalize(data, companySchema);
                dispatch(requestCompanySuccess(entities, result));
            })
            .catch(err => requestCompanyFailure(err));
    };
}

// ----------------------------------------------------------------------
function requestCompanies() {
    return { type: REQUEST_COMPANIES };
}
function requestCompaniesFailure(error) {
    return { type: REQUEST_COMPANIES_FAILURE, error };
}
function requestCompaniesSuccess(entities, result) {
    return {
        type: REQUEST_COMPANIES_SUCCESS,
        receivedAt: Date.now(),
        entities,
        company: result
    };
}

export function fetchCompanies() {
    return dispatch => {
        dispatch(requestCompanies());
        return requestWithAuth(dispatch, http =>
            http.get(`${API_URL}/companies`)
        )
            .then(({ data }) => {
                const { companies } = data;
                const { entities, result } = normalize(companies, [
                    companySchema
                ]);
                dispatch(requestCompaniesSuccess(entities, result));
            })
            .catch(err => requestCompaniesFailure(err));
    };
}

// ----------------------------------------------------------------------
function requestCompanyTeams() {
    return { type: REQUEST_COMPANY_TEAMS };
}
function requestCompanyTeamsFailure(error) {
    return { type: REQUEST_COMPANY_TEAMS_FAILURE, error };
}
function requestCompanyTeamsSuccess(entities, result) {
    return {
        type: REQUEST_COMPANY_TEAMS_SUCCESS,
        receivedAt: Date.now(),
        entities,
        company: result
    };
}
export function fetchTeamsByCompanyId(companyId) {
    return dispatch => {
        dispatch(requestCompanyTeams());
        return requestWithAuth(dispatch, http =>
            http.get(`${API_URL}/companies/${companyId}/teams`)
        )
            .then(({ data }) => {
                const { teams } = data;
                const { entities, result } = normalize(teams, [teamSchema]);
                dispatch(requestCompanyTeamsSuccess(entities, result));
            })
            .catch(err => requestCompanyTeamsFailure(err));
    };
}



// WEBPACK FOOTER //
// ./src/modules/companies/actions.js